import { writable } from 'svelte/store';

export let mainPaneWidth = writable("100%");
export let additionalDetailsPaneWidth = writable("0%");
export let additionalDetailsPaneContent = writable("");
export let additionalDetailKey = writable('');
